import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { memo } from 'react';
import { Popover } from 'antd';

import GroupAvatar from '../../../../src/components/UI/atoms/side-navbar/GroupAvatar.jsx';
import { joinProject } from '../../../actions';
import { getProjectColourPalette } from '../../../js/helper';

const ProjectPopover = ({ children, project, color = '' }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.userReducer);

  const { title = '', access, requestedAccess = false, updatedAt, participants, _id } = project || {};

  const isPublic = access === 'public';
  const palette = getProjectColourPalette(color);
  const initials = title?.slice(0, 2)?.toUpperCase() || '';
  const date = new Date(updatedAt).toLocaleDateString('en-us', { month: 'short', day: 'numeric', year: 'numeric' });

  const handleClick = () => {
    if (participants?.find(p => p?._id === user?._id)) {
      navigate(`/${_id}/board`);
    } else {
      dispatch(joinProject({ projectId: _id, role: 'member', isPublic: access === 'public' }));
    }
  };

  const accessLabel = requestedAccess ? 'Pending' : access;
  const accessBg = requestedAccess
    ? 'rgba(0,0,0,0.06)'
    : isPublic
      ? 'rgba(34,197,94,0.1)'
      : 'rgba(99,102,241,0.1)';
  const accessColor = requestedAccess ? '#64748b' : isPublic ? '#16a34a' : '#4f46e5';

  return (
    <Popover
      content={
        <div style={{ width: 280 }} className="cursor-pointer" onClick={handleClick}>
          {/* Color band with project icon */}
          <div
            className="flex items-center justify-center"
            style={{ background: palette.bg, borderBottom: `1px solid ${palette.border}`, height: 80, borderRadius: '10px 10px 0 0' }}
          >
            <span
              className="font-bold text-2xl"
              style={{ color: palette.text, letterSpacing: '0.06em', filter: 'brightness(0.6)' }}
            >
              {initials}
            </span>
          </div>
          {/* Info */}
          <div className="px-4 py-3">
            <div className="font-semibold text-sm text-slate-800 truncate">{title}</div>
            <div className="text-xs text-slate-400 mt-0.5">Updated {date}</div>
            <div className="flex items-center justify-between mt-3">
              <span
                className="text-xs font-medium px-2.5 py-1 rounded-lg capitalize"
                style={{ background: accessBg, color: accessColor }}
              >
                {accessLabel}
              </span>
              <GroupAvatar participants={participants} size={24} count={1} />
            </div>
          </div>
        </div>
      }
      trigger="hover"
      arrow={false}
      overlayInnerStyle={{ padding: 0, borderRadius: 12, overflow: 'hidden', boxShadow: '0 8px 24px rgba(0,0,0,0.12)' }}
    >
      {children}
    </Popover>
  );
};

export default memo(ProjectPopover);
